// Servicio para actualizar presupuestos totales iniciales
export const actualizarPresupuestoTotalInicial = async (proyectoId) => {
  try {
    console.log(`🔄 Actualizando presupuesto total inicial para proyecto: ${proyectoId}`);
    
    const response = await fetch('http://localhost:4001/api/recalcular-presupuesto-inicial', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ proyecto_id: proyectoId })
    });
    
    const resultado = await response.json();
    
    if (resultado.success) {
      console.log('✅ Presupuesto total inicial actualizado:', resultado.data);
      return { success: true, data: resultado.data };
    } else {
      console.error('❌ Error actualizando presupuesto total inicial:', resultado.error);
      return { success: false, error: resultado.error };
    }
  } catch (error) {
    console.error('❌ Error llamando al endpoint de actualización:', error);
    return { success: false, error: error.message };
  }
};

// Servicio para actualizar presupuestos totales actualizados
export const actualizarPresupuestoTotalActualizado = async (proyectoId) => {
  try {
    console.log(`🔄 Actualizando presupuesto total actualizado para proyecto: ${proyectoId}`);
    
    const response = await fetch('http://localhost:4001/api/recalcular-presupuesto-actualizado', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ proyecto_id: proyectoId })
    });
    
    const resultado = await response.json();
    
    if (resultado.success) {
      console.log('✅ Presupuesto total actualizado:', resultado.data);
      return { success: true, data: resultado.data };
    } else {
      console.error('❌ Error actualizando presupuesto total actualizado:', resultado.error);
      return { success: false, error: resultado.error };
    }
  } catch (error) {
    console.error('❌ Error llamando al endpoint de actualización:', error);
    return { success: false, error: error.message };
  }
};

// Servicio para recalcular presupuestos iniciales actualizados
export const recalcularPresupuestosInicialesActualizados = async (proyectoId) => {
  try {
    console.log(`🔄 Recalculando presupuestos iniciales actualizados para proyecto: ${proyectoId}`);
    
    const response = await fetch('http://localhost:4001/api/pia/recalcular-proyecto', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ proyecto_id: proyectoId })
    });
    
    const resultado = await response.json();
    
    if (resultado.success) {
      console.log('✅ Presupuestos iniciales actualizados recalculados exitosamente');
      return { success: true };
    } else {
      console.error('❌ Error recalculando presupuestos iniciales actualizados:', resultado.error);
      return { success: false, error: resultado.error };
    }
  } catch (error) {
    console.error('❌ Error llamando al endpoint de recálculo:', error);
    return { success: false, error: error.message };
  }
};

// ✅ NUEVO: Servicio para sincronizar tablas Dashboard desde presupuestos_iniciales_actualizados
export const sincronizarDashboard = async (proyectoId) => {
  try {
    console.log(`🔄 Sincronizando Dashboard para proyecto: ${proyectoId}`);
    
    const response = await fetch('http://localhost:4001/api/sincronizar-dashboard', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ proyecto_id: proyectoId })
    });
    
    const resultado = await response.json();
    
    if (resultado.success) {
      console.log('✅ Dashboard sincronizado exitosamente', resultado.data);
      return { success: true, data: resultado.data };
    } else {
      console.error('❌ Error sincronizando Dashboard:', resultado.error);
      return { success: false, error: resultado.error };
    }
  } catch (error) {
    console.error('❌ Error llamando al endpoint de sincronización:', error);
    return { success: false, error: error.message };
  }
};

// ✅ NUEVO: Servicio para proceso completo (actualizar tabla optimizada + sincronizar Dashboard)
export const actualizarYSincronizarProyecto = async (proyectoId) => {
  try {
    console.log(`🚀 Proceso completo para proyecto: ${proyectoId}`);
    
    const response = await fetch('http://localhost:4001/api/actualizar-y-sincronizar-proyecto', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ proyecto_id: proyectoId })
    });
    
    const resultado = await response.json();
    
    if (resultado.success) {
      console.log('✅ Proceso completo exitoso', resultado.data);
      return { success: true, data: resultado.data };
    } else {
      console.error('❌ Error en proceso completo:', resultado.error);
      return { success: false, error: resultado.error };
    }
  } catch (error) {
    console.error('❌ Error llamando al endpoint del proceso completo:', error);
    return { success: false, error: error.message };
  }
}; 

// ✅ Helper: disparar PIA → totales en segundo plano (sin await)
export const dispararActualizacionEnSegundoPlano = (proyectoId) => {
  try {
    // No bloquear UI ni propagar errores
    fetch('http://localhost:4001/api/actualizar-y-sincronizar-proyecto', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ proyecto_id: proyectoId })
    }).catch(() => {});
  } catch (_) {
    // Silencioso
  }
}; 